import { useLang } from "../contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-cb-dark text-white">
      <div className="container-cb py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-cb-gold grid place-items-center text-cb-primary">
              <span style={{ fontFamily: "Outfit", fontWeight: 700 }}>CB</span>
            </div>
            <div>
              <div className="font-semibold" style={{ fontFamily: "Outfit" }}>Capital Bay</div>
              <div className="text-[11px] tracking-widest uppercase text-white/60">Management Consulting</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/70 max-w-sm">{t.footer.tag}</p>
          <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-xs">
            <span className="w-1.5 h-1.5 rounded-full bg-cb-gold" />
            {t.footer.vision}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">{t.footer.links}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="text-white/80 hover:text-cb-gold">{t.footer.services}</a></li>
            <li><a href="#industries" className="text-white/80 hover:text-cb-gold">{t.footer.industries}</a></li>
            <li><a href="#healthcheck" className="text-white/80 hover:text-cb-gold">{t.footer.healthcheck}</a></li>
            <li><a href="#contact" className="text-white/80 hover:text-cb-gold">{t.footer.contact}</a></li>
          </ul>
        </div>
        <div className="md:col-span-4 text-sm text-white/70 space-y-2">
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">Riyadh, KSA</div>
          <div>Al Malaz, Riyadh</div>
          <div>Kingdom of Saudi Arabia</div>
          <div className="pt-2">
            <a href="mailto:capital.bay@outlook.com?subject=Financial%20Management%20Heath%20Check" className="hover:text-cb-gold">capital.bay@outlook.com</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-cb py-5 text-xs text-white/50 flex flex-wrap items-center justify-between gap-2">
          <div>{t.footer.copyright.replace("©", `© ${year}`)}</div>
          <div>Riyadh · Jeddah · Dammam</div>
        </div>
      </div>
    </footer>
  );
}
